<template>
  <div class="pagination-wrapper">
    <div class="pagination-left">
      <div>{{ entryText }}</div>
    </div>
    <nav class="pagination-nav">
      <div class="navigation-pane">
        <ul class="pagination mb-0">
          <li :class="{ 'page-item': true, disabled: currentPage <= 1 }">
            <a
              class="page-back"
              @click="setPage($event, currentPage - 1)"
              :class="{ 'page-link': true, cursor: currentPage > 1 }"
              >&laquo;</a
            >
          </li>
          <li
            v-for="page of shownPages"
            class="page-item page"
            :class="{
              active: page === currentPage
            }"
            :key="page"
          >
            <a
              v-bind:class="{
                'page-link': true,
                cursor: currentPage !== page
              }"
              @click="setPage($event, page)"
              >{{ page }}</a
            >
          </li>
          <li
            :class="{
              'page-item': true,
              disabled: currentPage >= maxPage
            }"
          >
            <a
              @click="setPage($event, currentPage + 1)"
              :class="{
                'page-link': true,
                cursor: currentPage < maxPage
              }"
              >&raquo;</a
            >
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    listLength: {
      type: Number,
      required: true
    }
  },

  computed: {
    entryText() {
      const start = (this.currentPage - 1) * this.pageSize + 1;
      const end = Math.min(this.currentPage * this.pageSize, this.listLength);
      return `Showing ${start} to ${end} out of ${this.listLength} entires.`;
    },
    maxPage() {
      return Math.ceil(this.listLength / this.pageSize);
    },
    shownPages() {
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.maxPage, start + 4);

      if (end === this.maxPage) start = Math.max(1, end - 4);

      let pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },

  methods: {
    setPage(event, page) {
      event.stopPropagation();

      if (page < 1) return;

      if (page > this.maxPage) return;

      this.$emit('onSetPage', page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;

  @media screen and (max-width: 485px) {
    justify-content: space-between;
  }

  .pagination-left {
    display: flex;
    justify-content: space-between;
    font-size: 0.75rem;

    // @media screen and (max-width: 485px) {
    //   display: none;
    // }
  }

  .pagination-nav {
    display: flex;
    flex-direction: row;

    .navigation-pane {
      display: flex;
      flex-direction: row;
    }
    .pagination {
      height: 2.25rem;

      // .page {
      // @media screen and (max-width: 485px) {
      //   display: none;
      // }
      // }

      li {
        &.active {
          color: #fff !important;

          .page-link {
            border: none;
          }
        }

        &.disabled {
          cursor: not-allowed;
        }
      }

      .page-link {
        border: 1px solid $text-grey;
        height: 2.25rem;
        width: 2.25rem;
      }

      .page-item.disabled .page-link {
        color: #aaa;
        border-color: #aaa;
      }

      .page-back {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        display: inline-block;
      }
    }
  }
}
</style>
